'use strict';

angular.module('jericho', [
    //Templates cache
    'templates',

    // Third party modules
    'ui.router',
    'ui.bootstrap',
    'js-data',


    // App modules
    'libraryModule',
    'broadcastsModule',
    'accessModule',
    'adminModule',
    'loginModule',
    'welcomeModule',
    'basketModule',
    'configModule',
    'integrationModule',
    'accessRequestModule',
    '2FaAuth',

    'angulartics',
    'angulartics.google.analytics',
])

.run(function ($rootScope, $state, appConfig)
{
    $rootScope.config = appConfig;
    $rootScope.state = $state;
})

.config(function ($locationProvider, $logProvider)
{
    $locationProvider
        .html5Mode(true)
        .hashPrefix('');
})

.config(function ($analyticsProvider)
{
    $analyticsProvider.firstPageview(true);
    $analyticsProvider.virtualPageviews(true);
})

.config(function (DSProvider)
{
    DSProvider.defaults.basePath = '/api/';
})

.config(function ($httpProvider)
{
    $httpProvider.useApplyAsync(true);
})

.config(function ($qProvider)
{
  //  $qProvider.errorOnUnhandledRejections(false);
})
